module.exports = __webpack_public_path__ + "static/img/u58.fa2f1a4d.png";